<template>
    <span>
        <button :class="getCSSClass('record-details-button')"
                v-on:click="showDetails"
                type="button"
                v-html="icon('details')"
        ></button>
        <popup :visible="showPopup"
               v-on:close="showPopup = false">
            <div v-if="this.subjectData != null"  :class="getCSSClass('record-details-container')">
                <div :class="getCSSClass('record-details-header')">
                    <span :class="getCSSClass('record-details-header-label')" v-html="translate('Hanglemez részletei')"></span>
                    <button :class="getCSSClass('record-details-close-button')"
                            v-on:click="showPopup = false"
                            type="button"
                            v-html="icon('close')+translate('Bezár')"
                            style="margin-left: auto"
                    ></button>
                </div>
                <div :class="getCSSClass('record-details-body')">
                    <div :class="getCSSClass('record-details-basedata-row')">
                        <div :class="getCSSClass('record-details-basedata-list-container')">
                            <ul style="list-style: none" :class="getCSSClass('record-details-basedata-list')">
                                <li :class="getCSSClass('record-details-basedata-list-item')">
                                    <label v-html="translate('Lemez címe')"></label><span v-html="subjectData.title"></span>
                                </li>
                                <li :class="getCSSClass('record-details-basedata-list-item')">
                                    <label v-html="translate('Kiadás éve')"></label><span v-html="subjectData.year_of_release"></span>
                                </li>
                                <li :class="getCSSClass('record-details-basedata-list-item')">
                                    <label v-html="translate('Időtartam (ÓÓ:PP:MM)')"></label><span v-html="subjectData.duration_human_label"></span>
                                </li>
                                <li :class="getCSSClass('record-details-basedata-list-item')">
                                    <label v-html="translate('Kiadó(k)')"></label><span v-html="subjectData.publishers_label"></span>
                                </li>
                            </ul>
                        </div>
                        <div :class="getCSSClass('record-details-cover-container')">
                            <lightbox :image-url="subjectData.image_path" max-thumb-height="auto"></lightbox>
                        </div>
                    </div>
                    <div :class="getCSSClass('record-details-songs-row')">
                        <table :class="getCSSClass('record-details-songs-table')">
                            <thead :class="getCSSClass('record-details-songs-table-head')">
                            <tr>
                                <th v-html="translate('Ssz')"></th>
                                <th v-html="translate('Szerző(k)')"></th>
                                <th v-html="translate('Zenedarab')"></th>
                                <th v-html="translate('Szólisták')"></th>
                                <th v-html="translate('Zenekari tagok')"></th>
                                <th v-html="translate('Zenekarok')"></th>
                                <th v-html="translate('Külsős közreműködők')"></th>
                                <th v-html="translate('Koncertmester')"></th>
                            </tr>
                            </thead>
                            <tbody :class="getCSSClass('record-details-songs-table-body')">
                                <tr v-for="song, songIndex in subjectData.songs"
                                     :class="getCSSClass('record-details-song-row')"
                                >
                                    <td v-html="(songIndex + 1).toString()"></td>
                                    <td v-html="recordOrSongField(song, 'composers_label')"></td>
                                    <td v-html="song.title"></td>
                                    <td v-html="recordOrSongField(song, 'soloists_label')"></td>
                                    <td v-html="recordOrSongField(song, 'orchestramembers_label')"></td>
                                    <td v-html="recordOrSongField(song, 'musicbands_label')"></td>
                                    <td v-html="recordOrSongField(song, 'externalcontributors_label')"></td>
                                    <td v-html="recordOrSongField(song, 'concertmasters_label')"></td>
                                </tr>

                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </popup>
    </span>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            operationsUrl: {type: String},
            subject: {},
        },
        data: function () {
            return {
                showPopup: false,
                subjectData: null,
            }
        },
        mounted() {
        },
        methods: {
            recordOrSongField: function(song, field) {
                if (song[field] != '') {
                    return song[field];
                }
                return this.subjectData[field];
            },
            showDetails: function() {
                this.fetchSubject(() => {
                    this.showPopup = true;
                })
            },
            fetchSubject: function(callback) {
                window.axios.get(this.currentUrl)
                    .then((response) => {
                        this.subjectData = response.data;
                        callback();
                    })
            }
        },
        computed: {
            currentUrl: function() {
                return this.operationsUrl.replace('___id___', this.subject.id);
            }
        },
        watch: {
            showPopup: function(value) {
                if (!value) {
                    this.subjectData = null;
                }
            }
        }

    }
</script>
